import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { deserialize } from "../../shared/models/base-helper";
import { Dashboard } from "../../shared/models/dashboard.model";

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  apiUrl = environment.apiUrl + '/dashboards/';

  constructor(readonly http: HttpClient) {}

  getDashboards(type: string): Observable<Dashboard[]> {
    return this.http.get<any[]>(`${this.apiUrl}${type}/`).pipe(
      map(results => results.map((dashboard: any) => deserialize(dashboard, Dashboard))),
    );
  }

  createNew(dashboard: any) {
    return this.http.post<any>(this.apiUrl, dashboard).pipe(map((response: any) => deserialize(response, Dashboard)));
  }

  update(dashboardId: number, dashboard: any) {
    return this.http.put<any>(`${this.apiUrl}${dashboardId}/`, dashboard).pipe(
      map((response: any) => deserialize(response, Dashboard)),
    );
  }

  delete(id: number) {
    return this.http.delete(`${this.apiUrl}${id}/`).pipe(
      map((response: any) => deserialize(response, Dashboard)),
    );
  }
}
